import * as storeConst from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall, handleProgramServiceError } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import { LIST_BIOMETRIC_CATEGORIES } from "../basic_program_biometric_data/constants";

export const state = {
  healthyRange: {
    [LIST_BIOMETRIC_CATEGORIES.SYSTOLIC_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.DIASTOLIC_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.WAIST_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.TC_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.HDL_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.TRIGLYCERIDES_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.FAST_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.NON_FAST_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.BMI_CODE]: {},
    [LIST_BIOMETRIC_CATEGORIES.TC_HDL_CODE]: {}
  }
};

export const getters = {
  [storeConst.GETTERS_LIST_HEALTHY_RANGE]: state => {
    return state.healthyRange;
  }
};

export const actions = {
  [storeConst.ACTIONS_SET_LIST_HEALTHY_RANGE]: ({ commit }, options) => {
    commit(storeConst.MUTATIONS_SET_LIST_HEALTHY_RANGE, options.data);
    if (options.callback) {
      options.callback();
    }
  },

  [storeConst.ACTIONS_ADD_HEALTHY_RANGE]: ({ commit }, options) => {
    const url = getEndPoints().programHealtyRange.add;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(() => {
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },

  [storeConst.ACTIONS_EDIT_HEALTHY_RANGE]: ({ commit }, options) => {
    const url = getEndPoints().programHealtyRange.update.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("PUT", options.data), commit)
      .then(() => {
        if (options.successMessage) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },

  [storeConst.ACTIONS_INIT_HEALTHY_RANGE]: ({ commit }, options) => {
    const url = getEndPoints().programHealtyRange.init;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_LIST_HEALTHY_RANGE, response);
        if (options.successMessage) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  }
};

export const mutations = {
  [storeConst.MUTATIONS_SET_LIST_HEALTHY_RANGE]: (state, payload) => {
    if (payload) {
      let result = Object.assign({}, state.healthyRange);
      payload.forEach(item => {
        result[item.biometricCode] = item;
      });
      state.healthyRange = result;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_healthy_range/index.js